import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Modal from './Modal';
import ContactForm from './ContactForm';
import QuestionForm from './QuestionForm';

const CallToAction = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);

  return (
    <>
      <section className="cta">
        <div className="cta-container">
          <h2>Two ways to work with what I've built</h2>
          <p>
            If you have a project that needs to get built, tell me about it — I take on a small
            number of engagements at a time. If you'd rather just use something today, my apps
            are bought once and yours to keep.
          </p>
          <div className="cta-buttons">
            <button
              className="btn btn-primary"
              onClick={() => setShowContactModal(true)}
            >
              Work with me →
            </button>
            <Link to="/apps" className="btn btn-secondary">
              See my apps
            </Link>
          </div>
          <p className="cta-guarantee">
            First conversation is free. Or just{' '}
            <button
              type="button"
              className="cta-inline-link"
              onClick={() => setShowQuestionModal(true)}
            >
              ask me a question
            </button>.
          </p>
        </div>
      </section>

      <Modal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
        title="Start a conversation"
      >
        <ContactForm onClose={() => setShowContactModal(false)} />
      </Modal>

      <Modal
        isOpen={showQuestionModal}
        onClose={() => setShowQuestionModal(false)}
        title="Ask a question"
      >
        <QuestionForm onClose={() => setShowQuestionModal(false)} />
      </Modal>
    </>
  );
};

export default CallToAction;
